// CSS
import './Scss/index.css';
// polyfills
import './polyfills';

import React from 'react';
import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { PrivateRoute } from './Authentication/PrivateRoute';
import AppConstants from './AppConstants';
import '../src/Utils/i18n';
import G2WAnalyticsApp from './Application/G2WAnalyticsApp';
import rootReducer from './Reducks/RootReducer';
import rootSagas from './Reducks/RootSagas';
import { initializeMixpanel } from './Telemetry/Mixpanel/mixpanelClient';
import AuthenticateComponent from './Authentication/AuthenticateComponent';
import NotFoundComponent from './Components/ErrorComponents/NotFoundComponent';

// disabling default service worker
// import { unregister } from './registerServiceWorker';

const sagaMiddleware = createSagaMiddleware();
const loggerMiddleware = createLogger({
  predicate: () => ['development', 'ed', 'rc', 'stage'].includes(AppConstants.APP_ENVIRONMENT)
});

let store = createStore(rootReducer, compose(applyMiddleware(sagaMiddleware, loggerMiddleware)));
rootSagas.forEach(saga => sagaMiddleware.run(saga));

initializeMixpanel();
ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Switch>
        <Route exact path="/authenticate" component={AuthenticateComponent} />
        <Route path="/analytics/accounts/:accountKey" component={PrivateRoute(G2WAnalyticsApp, true)} />
        <Route path="/analytics" component={PrivateRoute(G2WAnalyticsApp)} />
        <Redirect exact from="/" to="/analytics" />
        <Route component={NotFoundComponent} />
      </Switch>
    </Router>
  </Provider>,
  document.getElementById('root')
);
// unregister();



// WEBPACK FOOTER //
// ./src/index.js